__turbopack_context__.v({
  "container": "makers-module-scss-module__SXjpmq__container",
  "container__header": "makers-module-scss-module__SXjpmq__container__header",
  "container__items": "makers-module-scss-module__SXjpmq__container__items",
  "header__count": "makers-module-scss-module__SXjpmq__header__count",
  "header__letter": "makers-module-scss-module__SXjpmq__header__letter",
});
